





































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
  getVideoListByPage,
  getVrListByPage,
  getVideoListByPageNew,
} from "@/axios";

@Component({
  name: "vrVideo",
})
export default class extends Vue {
  @Prop()
  inputVrVideoData: any;

  @Prop()
  inputLandmarkShopData: any;

  // 右侧推荐(video)
  private recommend: any = [];
  // 中间内容数据(video)
  private mainList: any = [];
  // 右侧推荐(vr)
  private recommendVR: any = [];
  // 中间内容数据(vr)
  private mainListVR: any = [];

  // cityList
  private cityList: any = [];

  private listCount: any = 0;
  private eightBlessingsList: any = [];

  private vrManageCount: any = 0;
  private videoCount: any = 0;

  @Watch("inputVrVideoData", { immediate: true, deep: true })
  oninputVrVideoData(val: any, oldVal: any) {
    if (val) {
      this.recommend = val.recommendVideo;
      // this.mainList = val.videoArray;
      this.recommendVR = val.recommendVrManage;
      // this.mainListVR = val.vrManageArray;
      this.cityList = val.cityList;
      this.vrManageCount = val.vrManageCount;
      this.videoCount = val.videoCount;
      this.listCount = val.vrManageCount;
      // console.log('inputVrVideoData-------',val);

      // this.getData();
    }
  }

  private switchItemIndex(index: any) {
    // console.log('this.tabItemIndex---',this.tabItemIndex,index)
    if (this.tabItemIndex == index) {
      return false;
    }
    this.tabItemIndex = index;
    this.page = 1;
    this.getData();
  }

  // @Watch("tabItemIndex", {immediate: true, deep: true})
  // ontabItemIndex(val: any, oldVal: any) {
  //   if( val == 0 ){
  //     this.recommend = this.vrVideoData.recommendVideo;
  //     this.mainList = this.vrVideoData.videoArray;
  //   } else {
  //     this.recommend = this.vrVideoData.recommendVrManage;
  //     this.mainList = this.vrVideoData.vrManageArray;
  //   }
  // }
  mounted() {
    this.getData();
  }
  private vrVideoData: any = {
    cityList: [],
    recommendVideo: [],
    recommendVrManage: [],
    videoArray: [],
    vrManageArray: [],
  };

  private cityItemIndex: any = 0;
  private WufuItemIndex: any = -1;
  private tabItemIndex: any = 0;
  private dialogShow: any = false;
  private videoUrl: any = "";

  private vrdialogShow: any = false;
  private vrUrl: any = "";

  private page: any = 1;
  private page_size: any = 9;
  private area_id: any = "";
  private goods_group_id: any = "";

  /**点城市
   * @param {*} index
   * @param {*} id
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-07 10:11:24
   */
  private tabCityItemIndex(index: any, id: any) {
    // console.log('tab----',index,id)
    this.cityItemIndex = index;

    this.area_id = id;
    this.page = 1;
    this.getData();
  }

  /**点五福
   * @param {*}
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-07 10:12:20
   */
  private tabWufuItemIndex(index: any, id: any) {
    // console.log('tab----',index,id)
    if (this.WufuItemIndex == index) {
      this.WufuItemIndex = -1;
      this.goods_group_id = 0;
    } else {
      this.WufuItemIndex = index;
      this.goods_group_id = id;
    }
    this.page = 1;
    this.getData();
  }

  /**鼠标移入效果
   * @param {*} index
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-07 10:12:37
   */
  private mouseoverIndex(index: any) {
    this.WufuItemIndex = index;
    // alert(index);
  }
  /**鼠标移出效果
   * @param {*} index
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-07 10:12:37
   */
  private mouseleaveIndex() {
    this.WufuItemIndex = -1;
  }

  private showVideo(url: any) {
    this.videoUrl = url;
    this.dialogShow = true;
    // console.log(url)
  }

  private showVr(url: any) {
    this.vrUrl = url;
    this.vrdialogShow = true;
    // console.log(url)
  }

  private pageChange(page: any) {
    this.page = page;
    this.getData();
  }

  private getData() {
    if (this.tabItemIndex == 0) {
      // 宣传视频getVideoListByPageNew
      // getVideoListByPage({
      //   page_size: this.page_size,
      //   page: this.page,
      //   area_id: this.area_id,
      //   goods_group_id: 2,
      // }).then((res: any) => {
      //   this.listCount = res.data.data.count;
      //   this.mainList = res.data.data.data;
      //   console.log("getVideoListByPage---------", res);
      // });
      getVideoListByPageNew({
        page_size: this.page_size,
        page: this.page,
        area_id: this.area_id,
        goods_group_id: this.goods_group_id,
      }).then((res: any) => {
        this.listCount = res.data.data.count;
        this.mainList = res.data.data.data;
        this.eightBlessingsList = res.data.data.eightBlessingsList;
        console.log("getVideoListByPageNew---------", res);
      });
    }
    if (this.tabItemIndex == 1) {
      getVrListByPage({
        page_size: this.page_size,
        page: this.page,
        area_id: this.area_id,
        goods_group_id: this.goods_group_id,
      }).then((res: any) => {
        this.listCount = res.data.data.count;
        this.mainListVR = res.data.data.data;
        // console.log('getVideoListByPage---------',res)
      });
    }
  }
}
